import React, { useState } from 'react';

const Contact: React.FC = () => {
    const linkedinUrl = "https://www.linkedin.com/in/michal-ch/";
    const email = "michalchamrad@gmail.com";
    const [copyFeedback, setCopyFeedback] = useState("CLICK TO COPY");

    const handleEmailCopy = async () => {
        try {
            await navigator.clipboard.writeText(email);
            setCopyFeedback("EMAIL COPIED");
        } catch {
            setCopyFeedback("COPY FAILED");
        }

        window.setTimeout(() => {
            setCopyFeedback("CLICK TO COPY");
        }, 2000);
    };

    return (
        <section id="contact" className="py-12 md:py-20">
            <div className="max-w-4xl mx-auto px-4">
                <h2 className="text-4xl md:text-6xl font-bold mb-8 md:mb-16">GET IN TOUCH</h2>
                
                <div className="brutalist-container mb-8 md:mb-12">
                    <div className="text-center">
                        <p className="text-base md:text-xl mb-3 md:mb-4">
                            INTERESTED IN COLLABORATION OR WANT TO DISCUSS
                        </p>
                        <p className="text-base md:text-xl mb-4 md:mb-6">
                            DIGITAL VENTURES • PROCESS AUTOMATION • ENTREPRENEURSHIP
                        </p>
                        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
                            <a
                                href={linkedinUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="brutalist-button w-full sm:w-auto text-center hover:-translate-y-1"
                            >
                                LINKEDIN
                            </a>

                            <button
                                type="button"
                                onClick={handleEmailCopy}
                                className="brutalist-button w-full sm:w-auto text-center hover:-translate-y-1"
                                aria-label="Copy email"
                            >
                                {email}
                            </button>
                        </div>
                        <p className="mt-3 text-sm md:text-base font-bold">{copyFeedback}</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;